"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resizeChangeHandler = exports.getVisiblePages = exports.configVisible = void 0;
var _constants = require("../../constants");
var _utils = require("../../utils");
/**
 *
 * SPEC
 * --
 * XS: 0, // extra small - 3 itens
 * --
 * SM: 376, // small - 6 itens
 * --
 * MD: 568, // medium 10 itens
 * --
 * LG: 768, // large - 10 itens
 * --
 * XL: 1200, // extra large - 10 itens
 * --
 */
var configVisible = exports.configVisible = function configVisible(event) {
  var width = window.innerWidth;
  var visiblePages = 3;
  if (width >= _constants.BREAKPOINT.SM && width < _constants.BREAKPOINT.MD) {
    visiblePages = 6;
  }
  if (width >= _constants.BREAKPOINT.MD && width < _constants.BREAKPOINT.LG) {
    visiblePages = 10;
  }
  if (width >= _constants.BREAKPOINT.LG) {
    visiblePages = 10;
  }
  return visiblePages;
};
var resizeChangeHandler = exports.resizeChangeHandler = function resizeChangeHandler(updateVisible) {
  (0, _utils.resizeChange)(function (event) {
    updateVisible(configVisible(event));
  });
};
var getVisiblePages = exports.getVisiblePages = function getVisiblePages(_ref) {
  var page = _ref.page,
    total = _ref.total,
    visiblePages = _ref.visiblePages;
  var allPagesVisible = total <= visiblePages;
  var middlePoint = page >= visiblePages && page < total;
  var endPoint = page === total;
  var map = [];
  var startPage;
  var endPage;
  if (allPagesVisible) {
    startPage = 1;
    endPage = total;
  } else if (middlePoint) {
    startPage = page - (visiblePages - 2);
    endPage = page + 1;
  } else if (endPoint) {
    startPage = page - (visiblePages - 1);
    endPage = total;
  } else {
    startPage = 1;
    endPage = visiblePages;
  }
  while (startPage <= endPage) {
    map.push(startPage);
    startPage++;
  }
  return map;
};